import type { FC, ReactNode } from 'react'
import type { LegalSection } from '@/components/generals/legal-page'

import LegalPage from '@/components/generals/legal-page'

const SECTIONS: Array<LegalSection> = [
    {
        id: 'acceptance',
        title: "پذیرش شرایط",
        paragraphs: [
            "با ساخت حساب یا استفاده از وب‌سایت، اپلیکیشن دسکتاپ و داشبورد آموزا، این شرایط را می‌پذیرید. اگر با بخشی از آن موافق نیستید، لطفاً از خدمات آموزا استفاده نکنید."
        ]
    },
    {
        id: 'account',
        title: "حساب کاربری",
        bullets: [
            "اطلاعاتی که هنگام ثبت‌نام وارد می‌کنید باید درست و به‌روز باشد.",
            "نگهداری از رمز عبور بر عهده شماست و نباید آن را در اختیار دیگران بگذارید.",
            "مسئولیت فعالیت‌هایی که با حساب شما انجام می‌شود با شماست.",
            "اگر گمان می‌کنید کسی بدون اجازه به حسابتان دسترسی پیدا کرده، رمز را عوض کنید و از فرم تماس به ما خبر دهید."
        ]
    },
    {
        id: 'acceptable-use',
        title: "استفاده مجاز",
        paragraphs: ["هنگام استفاده از آموزا متعهد می‌شوید که:"],
        bullets: [
            "محتوای دوره‌ها را بدون اجازه کپی، بازنشر یا به فروش نرسانید.",
            "با ابزارهای خودکار، اطلاعات سایت را به‌صورت انبوه استخراج نکنید.",
            "برای مختل کردن خدمات، دسترسی غیرمجاز یا آزار دیگر کاربران تلاش نکنید.",
            "محتوای غیرقانونی، توهین‌آمیز یا ناقض حقوق دیگران منتشر نکنید."
        ]
    },
    {
        id: 'intellectual-property',
        title: "محتوای دوره‌ها و مالکیت فکری",
        paragraphs: [
            "محتوای دوره‌ها متعلق به آموزا یا مدرسان آن‌هاست. با افزودن یک دوره به کتابخانه، اجازه استفاده شخصی و غیرتجاری از آن را دریافت می‌کنید، نه مالکیت آن را."
        ]
    },
    {
        id: 'your-courses',
        title: "دوره‌هایی که شما می‌سازید",
        bullets: [
            "مالکیت محتوایی که خودتان می‌سازید با شما باقی می‌ماند.",
            "با انتشار یک دوره، به آموزا اجازه می‌دهید آن را میزبانی، نمایش و در اختیار یادگیرندگان قرار دهد.",
            "باید حق استفاده از هر متن، تصویر یا منبعی را که در دوره به کار می‌برید داشته باشید.",
            "آموزا می‌تواند دوره‌ای را که این شرایط را نقض کند از دسترس خارج کند."
        ]
    },
    {
        id: 'ai-content',
        title: "محتوای تولیدشده با هوش مصنوعی",
        paragraphs: [
            "پاسخ‌های مربی هوشمند و محتوایی که با کمک هوش مصنوعی ساخته می‌شود ممکن است خطا داشته باشد. اطلاعات مهم را از منابع معتبر بررسی کنید. این محتوا جایگزین مشاوره تخصصی، پزشکی، حقوقی یا مالی نیست."
        ]
    },
    {
        id: 'payments',
        title: "اشتراک و خرید",
        paragraphs: [
            "شرایط هر اشتراک یا خرید، از جمله مبلغ، مدت و شرایط تمدید، پیش از پرداخت به‌روشنی نمایش داده می‌شود و بخشی از همین قوانین به شمار می‌آید."
        ]
    },
    {
        id: 'changes',
        title: "تغییر خدمات و این شرایط",
        paragraphs: [
            "آموزا ممکن است امکانات خود را به‌روز کند یا تغییر دهد. اگر این شرایط تغییر مهمی کند، تاریخ به‌روزرسانی بالای همین صفحه عوض می‌شود و ادامه استفاده از خدمات به معنای پذیرش نسخه تازه است."
        ]
    },
    {
        id: 'liability',
        title: "محدودیت مسئولیت",
        paragraphs: [
            "آموزا برای ارائه خدمات پایدار و دقیق تلاش می‌کند، اما خدمات همان‌گونه که هست ارائه می‌شود و تا جایی که قانون اجازه می‌دهد، آموزا مسئول خسارت‌های غیرمستقیم ناشی از استفاده از آن نیست."
        ]
    }
]

const TermsPage: FC = (): ReactNode => {
    return (
        <LegalPage
            title="قوانین و شرایط استفاده"
            description="قوانین استفاده از وب‌سایت، اپلیکیشن دسکتاپ و داشبورد آموزا."
            updated="۱۰ آبان ۱۴۰۵"
            intro="این شرایط، رابطه شما و آموزا را هنگام استفاده از وب‌سایت، اپلیکیشن دسکتاپ و داشبورد کاربری مشخص می‌کند. لطفاً پیش از ساخت حساب، آن را با دقت بخوانید."
            sections={SECTIONS}
        />
    )
}

export default TermsPage
